import { useLightMode } from '@/hooks/useLightMode'
import { useToasts } from '@/hooks/useToasts'
import { useTranslation } from 'react-i18next'

/**
 * Placeholder for the Send to Resolver action (ENG-35897). The backend isn't
 * wired up yet, so pressing the button only surfaces a toast saying so.
 */
export const useSendIncidentToResolver = (isRebrand = false) => {
  const { t } = useTranslation()
  const colorScheme = useLightMode()
  const { showWarning } = useToasts({ isRebrand, colorScheme })

  const send = () => {
    showWarning(t('incidents:send_to_resolver_not_wired_up'))
  }

  return { send }
}
